import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-detail-body" }
const _hoisted_2 = { class: "user-inp" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import { onMounted, reactive, ref } from 'vue';
import VueSelect from 'vue-select';
import { UserItem } from '@/services/entities/UserItem';
import { useUserStore } from '@/stores/user';
import { useAzureStore } from '@/stores/azure';
import { debounce } from '@/common/util';
import { Authorization } from '@/services/authenticate';
import { DxButton } from 'devextreme-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamMemberForm',
  props: {
    user: {Type: {} as UserItem, default: {} as UserItem},
    onlyLocalUsers: {Type: {} as boolean, default: false},
},
  setup(__props) {


const userStore = useUserStore();
const azureStore = useAzureStore();

const props = __props;

const state = reactive({
    canEditName: false,
    selected: ""
});

onMounted(async () => {
    await userStore.loadAll();
    await azureStore.loadGroupMembers();
});


const handleSearch = debounce(async (query: string) => {
    if (query != "")
        await azureStore.searchUser(query);
}, 500);

function selectedUser(option: any) {    
    if (!option) return;

    props.user.id = option.id;
    if (props.onlyLocalUsers) {
        props.user.email = option.email;
        props.user.firstName = option.firstName;
        props.user.lastName = option.lastName;
        props.user.fullName = option.fullName;
    }
    else {
        props.user.email = option.mail;
        props.user.firstName = option.givenName;
        props.user.lastName = option.surname;
        if (props.user.lastName && props.user.firstName) {
            props.user.fullName = `${option.givenName} ${option.surname}`;
        } else {
            props.user.fullName = option.mail;
        }        
    }    
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("label", null, "Email", -1)),
        (props.onlyLocalUsers)
          ? (_openBlock(), _createBlock(_unref(VueSelect), {
              key: 0,
              label: "email",
              options: _unref(userStore).getAll,
              clearable: false,
              reduce: (item) => item.id,
              modelValue: state.selected,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.selected) = $event)),
              "onOption:selected": _cache[1] || (_cache[1] = (a) => selectedUser(a)),
              disabled: false,
              appendToBody: true
            }, null, 8, ["options", "reduce", "modelValue"]))
          : (_openBlock(), _createBlock(_unref(VueSelect), {
              key: 1,
              label: "mail",
              options: _unref(azureStore).getGroupMembers,
              clearable: false,
              modelValue: props.user.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.user.email) = $event)),
              "onOption:selected": _cache[3] || (_cache[3] = (a) => selectedUser(a)),
              onSearch: _unref(handleSearch),
              disabled: false
            }, null, 8, ["options", "modelValue", "onSearch"]))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Given name", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "string",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((props.user.firstName) = $event)),
              disabled: !state.canEditName
            }, null, 8, _hoisted_4), [
              [_vModelText, props.user.firstName]
            ]),
            _createVNode(_unref(DxButton), {
              hint: "Enable/Disable editing user name",
              icon: "edit",
              onClick: _cache[5] || (_cache[5] = () => state.canEditName = !state.canEditName)
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Surname", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "string",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((props.user.lastName) = $event)),
            disabled: !state.canEditName
          }, null, 8, _hoisted_5), [
            [_vModelText, props.user.lastName]
          ])
        ])
      ])
    ])
  ]))
}
}

})